module.exports = __webpack_public_path__ + "media/images/nav_social/nav_instagram-9591c825938323e372961904f150635c.svg";